<template>
  <Card
    title="System Statuses"
    direction="column"
    color="background"
    background="sand"
    spacing="tad"
    as="section"
  >
    <div>
      <TextComponent type="heading4" color="background" as="h3">
        hackthe6ix.com
      </TextComponent>
      <img
        src="https://github.com/hack-the-6ix/hackthe6ix-landing/workflows/Production%20deploy%20CI/badge.svg"
      />
    </div>
    <div>
      <TextComponent type="heading4" color="background" as="h3">
        hackthe6ix.com/apply
      </TextComponent>
      <img
        src="https://github.com/hack-the-6ix/hackthe6ix/workflows/Production%20deploy%20CI/badge.svg"
      />
    </div>
    <div>
      <TextComponent type="heading4" color="background" as="h3">
        UI library
      </TextComponent>
      <img
        src="https://github.com/hack-the-6ix/ui-library/workflows/Storybook%20CI/badge.svg?branch=master"
      />
    </div>
    <div>
      <TextComponent type="heading4" color="background" as="h3">
        Admin dashboard
      </TextComponent>
      <img
        src="https://api.netlify.com/api/v1/badges/6d49ff46-9a96-41b7-bbe2-4203470812f0/deploy-status"
      />
    </div>
  </Card>
</template>

<script>
import TextComponent from '@hackthe6ix/vue-ui/Text';
import Card from '../../../containers/Card';

export default {
  name: 'SystemStatus',
  components: {
    TextComponent,
    Card,
  },
};
</script>
